<template>
  <q-form ref="technicianData">
    <section class="q-px-md q-py-lg flex column">
      <div class="col-12 row title-page">Dados do técnico</div>
      <div class="group-input col-12 row q-mt-lg">
        <label for="number_phone">Telefone (DDD + número)</label>
        <q-input
          id="number_phone"
          class="col-12 q-mt-sm"
          bg-color="white"
          color="red-9"
          v-model="contract.numberPhone"
          dense
          outlined
          mask="(##) #####-####"
          placeholder="(##) #####-####"
          unmasked-value
          :rules="[
            (val) => (val && val.length > 0) || 'Campo Obrigatório',
            (val) => val.length > 10 || 'O número informado não parece valido.',
          ]"
          lazy-rules
          :disable="disableInputPhoneNumber"
        >
          <template v-slot:after>
            <q-btn
              round
              color="red-9"
              icon="edit"
              @click="disableInputPhoneNumberFunction"
            />
          </template>
        </q-input>
      </div>
      <div class="group-input col-12 row q-mt-lg">
        <label for="credenciada">Credenciada</label>
        <q-select
          id="accredited"
          class="col-12 q-mt-sm"
          outlined
          dense
          v-model="contract.accredited"
          color="red-9"
          use-input
          hide-selected
          fill-input
          input-debounce="0"
          :options="optionsAccredited"
          @filter="filterAccredited"
          option-value="value"
          option-label="text"
          emit-value
          bg-color="white"
          :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
          lazy-rules
          :disable="disableInputAccredited"
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"> Sem resultado </q-item-section>
            </q-item>
          </template>
          <template v-slot:after>
            <q-btn
              round
              color="red-9"
              icon="edit"
              @click="disableInputAccreditedFunction"
            />
          </template>
        </q-select>
      </div>
    </section>
  </q-form>
</template>

<script>
import { onMounted, ref } from "vue";

export default {
  name: "technicianData",
  props: {
    contract: String,
    optionsItens: {
      default:{}
    },
  },
  setup(props) {

    let disableInputPhoneNumber = ref(true);
    let disableInputAccredited = ref(true);
    let technicianData = ref(null);
    let optionsAccredited = ref([])

    onMounted(() => {
      optionsAccredited.value = props.optionsItens.optionsAccredited
    })
    
    function disableInputPhoneNumberFunction() {
      disableInputPhoneNumber.value = !disableInputPhoneNumber.value;
    }

    function disableInputAccreditedFunction() {
      disableInputAccredited.value = !disableInputAccredited.value;
    }

    async function validateForm() {
      return await technicianData.value.validate();
    }

    function filterAccredited(val, update) {
      update(() => {
        if (val === "") {
          optionsAccredited.value = props.optionsItens.optionsAccredited;
          return;
        }
      });
      update(() => {
        const needle = val.toLowerCase();
        optionsAccredited.value = props.optionsItens.optionsAccredited.filter(
          (v) => v.text.toLowerCase().indexOf(needle) > -1
        );
      });
    }

    

    return {
      technicianData,
      optionsAccredited,
      disableInputPhoneNumber,
      disableInputAccredited,
      disableInputPhoneNumberFunction,
      disableInputAccreditedFunction,
      filterAccredited,
      validateForm,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-page {
  font-size: 1rem;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: red;
  margin: 0;
}

label {
  font-weight: bold;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>
